import { IconListCheck } from '@tabler/icons-react';

import { Select } from '@optiro/ui';

import useMoveToNewTask from '@/hooks/useMoveToNewTask/useMoveToNewTask';
import { useTasksByProject } from '@/hooks/useTasks';
import { Interval, Task } from '@/types/types';

export interface MoveToNewTaskProps {
  interval: Interval;
  preselectedTaskId?: Task['id'];
}

const MoveToNewTask = ({ interval, preselectedTaskId }: MoveToNewTaskProps) => {
  const { data: assignments } = useTasksByProject(interval.project_id);
  const { mutate: moveToNewTask, isError } = useMoveToNewTask({ interval });

  const handleSubmit = (values: { task_id: string | number }) => {
    // Handle form submission logic here
    moveToNewTask({ interval, newTaskId: values.task_id });
  };

  const assignmentOptions =
    assignments?.map((task) => ({
      value: task.id.toString(),
      label: task.name,
    })) || [];

  return (
    <Select
      description={
        'Detaljer om opgaven vil blive vist på ressourcens opgaveoversigt. Hvis ikke valgt, vil bookingen være generel til projektet.'
      }
      placeholder="Vælg opgave"
      data={assignmentOptions}
      searchable
      size="md"
      leftSection={<IconListCheck size={16} />}
      clearable
      error={
        isError
          ? 'Den valgte ressource har allerede en booking i tidsrammen for denne opgave.'
          : undefined
      }
      label="Opgave"
      value={preselectedTaskId ? String(preselectedTaskId) : null}
      onChange={(value) => {
        handleSubmit({ task_id: value as string | number });
      }}
    />
  );
};

export { MoveToNewTask };
